import api from './api';

export const getTransakWidgetUrl = (widgetParams) =>
  api.post('/transak/widget-url', { widgetParams });
